import posthog from 'posthog-js'

import { trackAmplitude } from '@/shared/analytics/amplitude'

/**
 * Unified analytics entry point.
 *
 * Fans out a single track() call to every active provider (PostHog, Amplitude).
 * Adding or removing a provider only requires changing this file.
 *
 * Guard: PostHog requires a distinct_id to be assigned before events can be
 * meaningfully tracked (funnels break without it). We check here once so no
 * individual call site needs to carry this concern. Both providers are blocked
 * until PostHog is ready, keeping event streams consistent across tools.
 *
 * Usage:
 *   import { track } from '@/shared/analytics/analyticsService'
 *   track('my_event', { prop: value })
 */
export const track = (
	eventName: string,
	properties?: Record<string, unknown>
): void => {
	const distinctId = posthog.get_distinct_id?.()
	if (!distinctId) {
		console.warn(
			'[Analytics] PostHog distinct_id not ready, skipping:',
			eventName
		)
		return
	}

	posthog.capture(eventName, properties)
	trackAmplitude(eventName, properties)
}
